module.exports = __webpack_public_path__ + "static/example_12_months-d2c0b49a1fbd1cdf3b798cf5a8b0b1f8.png";